import _implicitStylesheets from "./icon.css";
import _implicitScopedStylesheets from "./icon.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate, sanitizeAttribute} from "lwc";
const $fragment1 = parseFragment`<svg${"a0:id"}${"c0"} xmlns="http://www.w3.org/2000/svg"${"a0:title"}${"a0:aria-hidden"}${2}><defs${3}><linearGradient${"a2:id"}${3}><stop offset="0%"${"a3:stop-color"}${3}/><stop${"a4:offset"}${"a4:stop-color"}${3}/><stop${"a5:offset"}${"a5:stop-color"}${3}/><stop offset="100%"${"a6:stop-color"}${3}/></linearGradient><linearGradient${"a7:id"}${3}><stop offset="0%" stop-color="var(--ads-icon-filled-stroke-color)"${3}/><stop offset="50%" stop-color="var(--ads-icon-filled-stroke-color)"${3}/><stop offset="50%" stop-color="var(--ads-icon-empty-stroke-color)"${3}/><stop offset="100%" stop-color="var(--ads-icon-empty-stroke-color)"${3}/></linearGradient></defs><use${"a12:xlink:href"}${3}/></svg>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, ncls: api_normalize_class_name, fid: api_scoped_frag_id, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.className),
    attrs: {
      "id": api_scoped_id("svg"),
      "title": $cmp.symbol,
      "aria-hidden": $cmp.ariaHidden
    }
  }, null), api_static_part(2, {
    attrs: {
      "id": api_scoped_id($cmp.generatedId)
    }
  }, null), api_static_part(3, {
    attrs: {
      "stop-color": $cmp._gradiant.color
    }
  }, null), api_static_part(4, {
    attrs: {
      "offset": $cmp._gradiant.percent,
      "stop-color": $cmp._gradiant.color
    }
  }, null), api_static_part(5, {
    attrs: {
      "offset": $cmp._gradiant.percent,
      "stop-color": $cmp._gradiant.empty
    }
  }, null), api_static_part(6, {
    attrs: {
      "stop-color": $cmp._gradiant.empty
    }
  }, null), api_static_part(7, {
    attrs: {
      "id": api_scoped_id("gradient-partial-star")
    }
  }, null), api_static_part(12, {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", api_scoped_frag_id($cmp.href))
    }
  }, null)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5a4v0d4vo3f";
tmpl.legacyStylesheetToken = "undefined-_icon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
